import { createContext, useContext, useRef, useState } from 'react';

const InteractionsListContext = createContext(null);

export const InteractionsListProvider = ({ children }) => {
  const [interactionsListCache, setInteractionsListCache] = useState(null);
  // A ref, not state: saving it happens in a Link's onClick right before the click's own
  // navigation unmounts the list, so it has to take effect synchronously - a setState here would
  // depend on that update committing before unmount, which isn't guaranteed.
  const scrollPositionRef = useRef(null);
  const [showLogInteractionModal, setShowLogInteractionModal] = useState(false);
  return (
    <InteractionsListContext.Provider
      value={{
        interactionsListCache,
        setInteractionsListCache,
        scrollPositionRef,
        showLogInteractionModal,
        setShowLogInteractionModal,
      }}
    >
      {children}
    </InteractionsListContext.Provider>
  );
};

export function useInteractionsList() {
  const context = useContext(InteractionsListContext);
  if (context == null) {
    throw new Error('useInteractionsList must be used within an InteractionsListProvider.');
  }
  return context;
}

export default InteractionsListContext;
